import { isCommonSimpleOrTest, isShopifyOrTest } from './platform';

type SubscribePayload =
  | {
      type: 'email';
      email: string;
    }
  | {
      type: 'phone';
      phoneCode: string;
      phone: string;
    };

interface ViewedPayload {
  popupType?: string;
  popupName?: string;
  triggerEventType?: number;
}

function isPopupCallbackEnabled() {
  return isCommonSimpleOrTest() || isShopifyOrTest();
}

export function triggerSubscribedCallback(payload: SubscribePayload) {
  if (!isPopupCallbackEnabled()) {
    return;
  }

  const onSubscribed = window?.CARTSEE_SUBSCRIBE?.onSubscribed;
  if (typeof onSubscribed === 'function') {
    onSubscribed(payload);
  }
}

export function triggerPhoneSubscribedCallback(payload: { phone: string; phoneCode?: string }) {
  triggerSubscribedCallback({
    type: 'phone',
    phone: payload.phone,
    phoneCode: payload.phoneCode ?? ''
  });
}

export function triggerViewedCallback(payload: ViewedPayload) {
  if (!isPopupCallbackEnabled()) {
    return;
  }

  const onViewed = window?.CARTSEE_SUBSCRIBE?.onViewed;
  if (typeof onViewed === 'function') {
    onViewed(payload);
  }
}
